import axios from "axios";
import React from 'react';
import ReactDOM from "react-dom";
import ExpiringAlert from '../components/ExpiringAlert';
import i18n from '../views/Pages/Login/i18n';

const client = axios.create();
client.interceptors.response.use(undefined, err => {
    if (err.response.status === 302) {
        const expiringAlert = <ExpiringAlert color="danger" message={i18n.t('error.redirect')}/>
        ReactDOM.render(expiringAlert, document.getElementById('alert'));
        return Promise.reject(i18n.t('error.redirect'));
    }
    // TODO: Interceptor needs to be updated to reject the Promise rather than resolve it,
    // to ensure that error handling in the calling code is triggered correctly.
    // As it is currently used in many places, a second shared client StrictClient.js has been created
    // and should be used to gradually migrate screens.
    return Promise.resolve(err);
});

export default client;